import React, { useState, useEffect } from 'react';
import image1 from "../../assets/Antibiotics/EBAMOX_CV_375.jpg"
import image2 from "../../assets/Antibiotics/EBAMOX_CV_625.jpg"
import image3 from "../../assets/Antibiotics/EBAMOX_CV_DRY_SYP.jpg"

const Ebamox = () => {
  const fetchdata = [
    {
      imageUrl: image1,
      title: 'EBAMOX CV 375',
      description: 'Amoxycillin 500mg/200mg + Potassium Clavulanic 125mg/28.5mg',
    },
    {
      imageUrl: image2,
      title: 'EBAMOX CV 625',
      description: 'Amoxycillin 500mg/200mg + Potassium Clavulanic 125mg/28.5mg',
    },
    {
      imageUrl: image3,
      title: 'EBAMOX CV DRY SYP',
      description: 'Amoxycillin 500mg/200mg + Potassium Clavulanic 125mg/28.5mg',
    },
  ];
  const [currentIndex, setCurrentIndex] = useState(0);

  // Function to update the current index and trigger a re-render
  const changeSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % fetchdata.length);
  };

  useEffect(() => {
    // Change slide every 3 seconds
    const interval = setInterval(changeSlide, 4000);

    // Clear the interval when the component unmounts
    return () => clearInterval(interval);
  });
  return (
    <>
      <div className="container mb-5">
        <div className="row">
          <div className="">
            <div className="card-products">
              <img
                src={fetchdata[currentIndex].imageUrl}
                alt={fetchdata[currentIndex].title}
                className="custom-image-height"
              />
              <div className="card-body-products">
                <h4 className='card-products-title'><b>  {fetchdata[currentIndex].title}</b></h4>
                <span className="author-products mt-4">{fetchdata[currentIndex].description}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}


export default Ebamox
